<template>
  <div :class="[{'fl_list_body_yoga':radio=='1'},'fl_list_body']">
    <div v-show="fl_stadium_list.length>0&&loaded==true">
      <div v-for="(stadium_item,stadium_index) in fl_stadium_list" class="fl_list_body_item">
        <div class="fl_list_body_item_imgMM">
          <img @click="FLDetail(stadium_item,stadium_index)" :src="stadium_item.thumb" class="fl_list_body_item_img" />
          <img class="fl_list_body_item_img_type" v-show="radio=='0'" src="../../assets/images/fl20210204/vip_reserve_type_fit.png" />
          <img class="fl_list_body_item_img_type" v-show="radio=='1'" src="../../assets/images/fl20210204/vip_reserve_type_yoga.png" />
        </div>
        <div class="fllpr_panel">
          <div class="fllpr_panel_txt">
            门市价
            <label v-show="radio=='0'" class="fllpr_panel_origin">¥{{((stadium_item.origin_price)/100).toFixed(0)}}</label>
            <label v-show="radio=='1'" class="fllpr_panel_origin">¥200</label>
            <label class="fllpr_panel_viper">会员价</label>

            <label v-show="radio=='0' && (((stadium_item.origin_price)/100)/2)%1 == 0" class="fllpr_panel_vipprice">¥{{(((stadium_item.origin_price)/100)/2).toFixed(0)}}</label>
            <label v-show="radio=='0' && (((stadium_item.origin_price)/100)/2)%1 != 0" class="fllpr_panel_vipprice">¥{{(((stadium_item.origin_price)/100)/2).toFixed(2)}}</label>


            <label v-show="radio=='1'" class="fllpr_panel_vipprice">¥100</label>
          </div>
          <div class="fllpr_panel_distance">
            <label v-if="stadium_item.distance != -1">{{stadium_item.distance}}</label>
            {{stadium_item.district}}
          </div>
        </div>
        <button @click="FLDetail(stadium_item,stadium_index)" v-show="stadium_item.is_black_vip!=1 && radio=='1'" class="fllpr_quickcreate">快速预约</button>
        <button @click="FLCreate(stadium_item,stadium_index)" v-show="stadium_item.stock>0 && stadium_item.is_black_vip!=1 && radio=='0'" class="fllpr_quickcreate">快速预约</button>
        <button @click="FLDetail(stadium_item,stadium_index)" v-show="stadium_item.is_black_vip!=1 && stadium_item.stock==0&& radio=='0'" class="fllpr_quickcreaten">今日已满</button>
        <div @click="FLDetail(stadium_item,stadium_index)" v-show="stadium_item.is_black_vip==1" class="fllpr_black">斐燃黑金专享</div>

      </div>
    </div>
    <div v-show="fl_stadium_list.length==0&&loaded==true">
      <div class="stadium_noHotel">
        <img class="stadium_noHotel_img" src="../../assets/images/base/no_hotel.png" />
        <div class="stadium_noHotel_title">暂无酒店</div>
        <div class="stadium_noHotel_cont">因新冠病毒疫情和政策法规，该地区酒店健身、瑜伽服务将逐渐开放预约</div>
      </div>
    </div>
  </div>
</template>
<!--
0 健身
1 瑜伽
 -->
<script>
  export default {
    props:{
      radio:String,
      loaded:Boolean,
      fl_stadium_list:Array,
    },
    data() {
      return {

      }
    },
    created() {},
    mounted() {

    },
    methods:{
      FLDetail(item,index){
        this.$emit('FLDetail',item,index)
      },
      FLCreate(item,index){
        this.$emit('FLCreate',item,index)
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fl_list_body{
    width: calc(100% - 0*@vm_base);
    margin-top: 40*@vm_base;
    padding: 0*@vm_base 32*@vm_base 0 32*@vm_base;
    height: calc(100vh - 40*@vm_base - 248*@vm_base);
    overflow: hidden;
    overflow-y: auto;
    .fl_list_body_item{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 120*@vm_base;
      position: relative;

      // border-radius: 12*@vm_base;
      // overflow: hidden;
      .fl_list_body_item_imgMM{
        width: 100%;
        overflow: hidden;
        border-radius: 12*@vm_base;
        position: relative;
        .fl_list_body_item_img_type{
          position: absolute;
          top: 0;
          right: 0;
          margin-top: 30*@vm_base;
          margin-right: 30*@vm_base;
          width: 70*@vm_base;
          box-shadow: 0 0 10*@vm_base 0 rgba(40, 40, 40, 0.5);
          border-radius: 4*@vm_base;
        }
      }
      .fl_list_body_item_img{
        height: 428*@vm_base;
      }
      .fllpr_panel{
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        width: calc(100% - 60*@vm_base);
        margin-left: 30*@vm_base;
        margin-bottom: -65*@vm_base;
        background: #FFFFFF;
        box-shadow: 0px 2*@vm_base 10*@vm_base 0px rgba(0, 0, 0, 0.1);
        border-radius: 12*@vm_base;
        padding: 28*@vm_base 30*@vm_base;

        .fllpr_panel_txt{
          width: 100%;
          font-size: 24*@vm_base;
          font-weight: 500;
          color: #666666;
          .fllpr_panel_origin{
            font-size: 32*@vm_base;
          }
          .fllpr_panel_viper{
            color: #C9914B;
          }
          .fllpr_panel_vipprice{
            font-size: 32*@vm_base;
            color: #C9914B;
          }
        }
        .fllpr_panel_distance{
          width: 100%;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: #999999;
          padding-left: 23*@vm_base;
          background-image: url(../../assets/images/FLVersion/nav_location_defaul.png);
          background-size: 15*@vm_base;
          background-repeat: no-repeat;
          background-position: left center;
          margin-top: 5*@vm_base;
        }
      }
      .fllpr_quickcreate{
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 2;
        width: 160*@vm_base;
        height: 64*@vm_base;
        border-radius: 32*@vm_base;
        border: 1px solid #444054;
        background: #FFFFFF;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #0A0A0A;
        margin-bottom: -30*@vm_base;
        margin-right: 60*@vm_base;
      }
      .fllpr_quickcreaten{
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 2;
        width: 160*@vm_base;
        height: 64*@vm_base;
        border-radius: 32*@vm_base;
        border: 1px solid #999999;
        background: #FFFFFF;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #999999;
        margin-bottom: -30*@vm_base;
        margin-right: 60*@vm_base;
      }
      .fllpr_black{
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 2;
        width: 220*@vm_base;
        height: 60*@vm_base;
        line-height: 60*@vm_base;
        background: linear-gradient(90deg, rgba(242, 206, 136, 0) 0%, #F2CE88 100%);

        text-align: center;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #000000;
        margin-bottom: -28*@vm_base;
        margin-right: 30*@vm_base;
      }
      .fl_list_body_item_distance{
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 40*@vm_base;

        font-size: 20*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 1;
        padding: 20*@vm_base 32*@vm_base;
        margin-top: 20*@vm_base;
        margin-left: 20*@vm_base;
        label{
          background-image: url(../../assets/images/base/location_hotelphoto.png);
          background-size: 12*@vm_base 16*@vm_base;
          background-repeat: no-repeat;
          background-position: left center;
          padding: 0 12*@vm_base 0 24*@vm_base;
        }
      }
      .fl_list_body_item_quick{
        position: absolute;
        bottom: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 32*@vm_base;
        margin-bottom: 20*@vm_base;
        margin-right: 20*@vm_base;
        color: #FFFFFF;
        font-size: 24*@vm_base;
        font-weight: 500;
        // line-height: 1;
        padding: 15*@vm_base 48*@vm_base 15*@vm_base 36*@vm_base;
        background-image: url(../../assets/images/base/orderArrow_white.png);
        background-size: 16*@vm_base 24*@vm_base;
        background-repeat: no-repeat;
        background-position: 90% center;
        // border: 1px solid red;
      }
      .fl_list_body_item_blackVip{
        width: 160*@vm_base;
        position: absolute;
        right: 0;
        top: 0;
        margin: 20*@vm_base 20*@vm_base 0 0;
      }
      .fl_list_body_item_full{
        width: 80*@vm_base;
        position: absolute;
        right: 0;
        top: 0;
        margin: 0 20*@vm_base 0 0;
      }
    }
  }
  .fl_list_body_yoga{
    height: calc(100vh - 40*@vm_base - 88*@vm_base);
  }
  // 无酒店
  .stadium_noHotel{
    width: 100%;
    background: #FFFFFF;
    border-radius: 12*@vm_base;
    padding: 14*@vm_base 60*@vm_base 60*@vm_base 60*@vm_base;
    .stadium_noHotel_img{
      width: 276*@vm_base;
      margin: 0 auto;
    }
    .stadium_noHotel_title{
      width: 100%;
      font-size: 28*@vm_base;
      font-weight: 500;
      color: #333333;
      margin-bottom: 15*@vm_base;
      text-align: center;
    }
    .stadium_noHotel_cont{
      width: 100%;
      font-size: 24*@vm_base;
      font-weight: 500;
      color: #B4B3BB;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/subgroup/appointmentList.vue